<template>
  <div id="app">
    <AppHeader />
    <main>
      <!-- Vue 2의 router-view 전환 문법으로 수정합니다. -->
      <!-- :key 속성은 URL이 변경될 때마다 페이지를 새로 그리도록 보장합니다. -->
      <transition name="fade" mode="out-in">
        <router-view :key="$route.fullPath" />
      </transition>
    </main>
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from "./components/AppHeader.vue";
import AppFooter from "./components/AppFooter.vue";

export default {
  name: "App",
  components: { AppHeader, AppFooter }
};
</script>

<style scoped>
/* App.vue의 스타일은 이제 이 컴포넌트의 레이아웃에만 집중합니다. */
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding-top: var(--header-height); /* 헤더 높이만큼 패딩 추가 */
}

/* 페이지 전환 애니메이션 스타일 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
